var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import ValidationInput from "@irati/utils/validation/Input";
import id from "@irati/utils/id";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import { FormGroup } from "@irati/ui/src/Form";
import ErrorText from "@irati/ui/src/ErrorText";
import { StyledCol, StyledLabel, CheckboxUI, CheckboxInput, CheckboxOutline } from "./styled";
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validation = new ValidationInput(_this);
        _this.state = {
            errorMsg: undefined
        };
        _this.componentDidUpdate = function (prevProps, prevState) { return _this.validation.update(prevProps, prevState); };
        _this.componentWillUnmount = function () { return _this.validation.destroy(); };
        _this.handleChange = function (event) { return _this.props.onChange(event); };
        return _this;
    }
    Checkbox.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.checked !== prevState.value) {
            return { value: nextProps.checked };
        }
        return null;
    };
    Checkbox.prototype.render = function () {
        var _a = this.state, errorMsg = _a.errorMsg, value = _a.value;
        var _b = this.props, className = _b.className, name = _b.name, disabled = _b.disabled, children = _b.children, flush = _b.flush;
        var idNamespace = id("checkbox", this.props);
        var idCheckbox = idNamespace || name;
        var validationState = errorMsg ? "error" : undefined;
        return (React.createElement(FormGroup, { flush: flush, controlId: idCheckbox, validationState: validationState },
            React.createElement(Col, { xs: 12 },
                React.createElement(CheckboxUI, { className: className },
                    React.createElement(CheckboxInput, { id: idCheckbox, type: "checkbox", checked: value, disabled: disabled, onChange: this.handleChange }),
                    React.createElement(CheckboxOutline, { htmlFor: idCheckbox, disabled: disabled })),
                React.createElement(StyledLabel, { id: id("label", idNamespace), htmlFor: idCheckbox }, children)),
            errorMsg && (React.createElement(StyledCol, { xs: 12 },
                React.createElement(ErrorText, { small: true }, getResolvedMessage(this, "errorMsg", this.state))))));
    };
    return Checkbox;
}(Component));
export default injectIntl(Checkbox);
